<script>
    import {twMerge} from "$m7-library/lib/twMerge";

    const {class: cls = "", width = "24", height = "24"} = $props()
</script>

<svg class={twMerge("tw:text-cyprus tw:h-6 tw:w-6", cls)} width="{width}" height="{height}" viewBox="0 0 63.012 57.908" fill="none"
     xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(-889.82 -1035.846)">
        <g transform="translate(889.82 1058.643)">
            <path fill="currentColor" d="M952.832,1054.735l-16.472,23.531a1.433,1.433,0,0,1-1.177.654h-.915l-13.6-19.61-1.045,1.569,12.546,17.911h-9.933a1.438,1.438,0,0,1-1.177-.654l-13.333-18.826-3.007,4.309-8.106,11.641h2.222l6.667-9.543,2.1,3.007-6.54,9.413a1.434,1.434,0,0,1-1.177.654H889.82l17.911-25.624,15.557,22.093h2.092l-10.067-14.38,5.361-7.713,14.512,20.656,10.981-15.687H932.7a1.178,1.178,0,0,1-1.177-1.177h0v-2.222Z" transform="translate(-889.82 -1053.166)"/>
        </g>
        <g transform="translate(896.556 1037.846)">
            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M894.782,1067.425v-10.709l24.259-18.869,22.54,17.532" transform="translate(-894.782 -1037.846)"/>
            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M943.081,1068.294v7.184a5.39,5.39,0,0,1-5.391,5.391H899.954a5.386,5.386,0,0,1-4.561-2.517" transform="translate(-894.563 -1026.961)"/>
        </g>
    </g>
</svg>
